export default __webpack_public_path__ + "static/media/daily-videos.cd9e3924.svg";